'use client'
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { stripHtml, cleanTitle } from '../../utils/helpers';
import Sidebar from '../home/Sidebar';
import { useSearchParams } from 'react-router-dom';


const EventMain = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [keyword, setKeyword] = useState(searchParams.get("keyword") || "");
  const [isSearching, setIsSearching] = useState(false);


   const [selectedEvent, setSelectedEvent] = useState(null);
    const [isSidebar, setIsSidebar] = useState(false);
    const handleSidebar = (eventData) => {
          setSelectedEvent(eventData);
          setIsSidebar(!isSidebar);
      }
  const wpUrl = process.env.REACT_APP_WP_URL;
  const [locationTree, setLocationTree] = useState([]);
  const [genres, setGenres] = useState([]);
  const [event_types, setEventTypes] = useState([]);
  const [artists, setArtists] = useState([]);
  const [states, setStates] = useState([]);
  const [organizers, setOrganizers] = useState([]);
  const [venue_types, setVenueType] = useState([]);
  const [entryoptions, setEntryoptions] = useState([]);
  const [allEvents, setAllEvents] = useState([]);
  const [allCategories] = useState([]);
  const [allState] = useState([]);

  // const [selectedLocation, setSelectedLocation] = useState(searchParams.get("location") || '');

  const [selectedGenre, setSelectedGenre] = useState(searchParams.get("festivalgenre") || '');
  const [selectedEntryOption, setSelectedEntryOption] = useState(searchParams.get("entry_option") || '');
  const [selectedEventType, setSelectedEventType] = useState(searchParams.get("event_type") || '');
  const [selectedVenueType, setSelectedVenueType] = useState(searchParams.get("venue_type") || '');
  const [selectedOrganizer, setSelectedOrganizer] = useState(searchParams.get("organizer") || '');
  const [selectedState, setSelectedState] = useState(searchParams.get("state") || '');
  const [selectedArtist, setSelectedArtist] = useState(searchParams.get("artist") || '');
  const [selectedMonth, setSelectedMonth] = useState(searchParams.get("month") || '');
  const [searchName, setSearchName] = useState(searchParams.get("event_name") || '');


  const [currentPage, setCurrentPage] = useState(1);
  const eventsPerPage = 10;

  const [filteredEvents, setFilteredEvents] = useState([]);

  const indexOfLastEvent = currentPage * eventsPerPage;
  const indexOfFirstEvent = indexOfLastEvent - eventsPerPage;
  const currentEvents = filteredEvents.slice(indexOfFirstEvent, indexOfLastEvent);

  const totalPages = Math.ceil(filteredEvents.length / eventsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const res = await fetch(`${wpUrl}wp-json/wp/v2/posts?status=publish&_embed&per_page=100`);
        const data = await res.json();

        
        // const sortedEvents = data.sort((a, b) => new Date(b.event_date) - new Date(a.event_date));
        const sortedEvents = data
        .filter(event => {
          const terms = event._embedded?.['wp:term']?.[0] || [];
          return !terms.some(cat => cat.slug === 'blog');
        })
        .sort((a, b) => new Date(b.event_date) - new Date(a.event_date));
        setAllEvents(sortedEvents);
        setFilteredEvents(sortedEvents);


        const categoryRes = await fetch(`${wpUrl}wp-json/wp/v2/categories?per_page=100`);
        const allCategoriesData = await categoryRes.json();

       

      //// get all catgories per event ////
      const [venueData, genreData, eventtypeData] = await Promise.all([
        fetch(`${wpUrl}wp-json/wp/v2/categories?slug=venue-type`).then(r => r.json()),
        fetch(`${wpUrl}wp-json/wp/v2/categories?slug=genre`).then(r => r.json()),
        fetch(`${wpUrl}wp-json/wp/v2/categories?slug=event-type`).then(r => r.json()),
      ]);

      const venueCat1 = venueData[0];
      const genreCat1 = genreData[0];
      const eventtypeCat1 = eventtypeData[0];

      if (!venueCat1 && !genreCat1 && !eventtypeCat1) {
        console.warn("No matching parent categories found.");
        return;
      }

      // 3. Fetch all subcategories
            const subcatFetches = [];

            if (venueCat1) {
                subcatFetches.push({
                type: 'venue_type',
                promise: fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${venueCat1.id}`)
                });
            }

            if (genreCat1) {
                subcatFetches.push({
                type: 'genre',
                promise: fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${genreCat1.id}`)
                });
            }

            if (eventtypeCat1) {
                subcatFetches.push({
                type: 'event_type',
                promise: fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${eventtypeCat1.id}`)
                });
            }

            const subcatDataArrays = await Promise.all(
                subcatFetches.map(async obj => ({
                type: obj.type,
                data: await (await obj.promise).json()
                }))
            );

            const allSubcategories = subcatDataArrays.flatMap(obj =>
                obj.data.map(sub => ({ ...sub, type: obj.type }))
            );

          
            const eventsWithCategories = sortedEvents.map(event => {
                const attachedCategories = event._embedded?.['wp:term']?.[0] || [];

                const matchedSubCategories = attachedCategories
                .map(attached => {
                    const match = allSubcategories.find(sub => sub.id === attached.id);
                    return match ? { ...attached, type: match.type} : null;
                })
                .filter(Boolean);

              
                        const entryOptions = attachedCategories.filter(term =>
                            term.link.includes('/category/entry-options/') && term.parent !== 0
                        );

                        return { 
                            ...event, 
                            categories: matchedSubCategories,
                            entry_options: entryOptions // 👈 attach per event
                        };
            });


             setAllEvents(eventsWithCategories);
        setFilteredEvents(eventsWithCategories);

          
        const venueTypeCat = allCategoriesData.find(cat => cat.name === 'Venue Type');
        if (venueTypeCat) {
          const venueChildrenRes = await fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${venueTypeCat.id}`);
          const venueChildren = await venueChildrenRes.json();
          setVenueType(venueChildren);
        }

         const genreCat = allCategoriesData.find(cat => cat.name === 'Genre');
        if (genreCat) {
          const genreChildrenRes = await fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${genreCat.id}`);
          const genreChildren = await genreChildrenRes.json();
          setGenres(genreChildren);
        }

        const entryoptionsCat = allCategoriesData.find(cat => cat.name === 'Entry Options');
        if (entryoptionsCat) {
          const entryoptionsChildrenRes = await fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${entryoptionsCat.id}`);
          const entryoptionsChildren = await entryoptionsChildrenRes.json();
          setEntryoptions(entryoptionsChildren);
        }

         const eventTypeCat = allCategoriesData.find(cat => cat.name === 'Event Type');
        if (eventTypeCat) {
          const eventtypeChildrenRes = await fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${eventTypeCat.id}`);
          const eventtypeChildren = await eventtypeChildrenRes.json();
          setEventTypes(eventtypeChildren);
        }

        const allStates = data.map(post => post.state).filter(Boolean);
        setStates([...new Set(allStates)].sort());

        

        const allArtists = data.flatMap(post => post.artist?.split(',').map(a => a.trim())).filter(Boolean);
        setArtists([...new Set(allArtists)].sort());

        const allOrganizers = data.flatMap(post => post.organizer?.split(',').map(a => a.trim())).filter(Boolean);
        setOrganizers([...new Set(allOrganizers)].sort());

        //// end dropdown data ////
      } catch (err) {
        console.error('Error:', err);
      }
    };

    fetchAllData();
  }, []);

  useEffect(() => {
   

     const results = allEvents.filter(event => {
       const terms = event._embedded?.['wp:term']?.[0] || [];

      const isUncategorized = terms.some(term => term.name === "Blog" || term.slug === "blog");
    if (isUncategorized) return false;

      const genreId = selectedGenre
        ? genres.find(g => g.slug === selectedGenre)?.id
        : null;

        const entryoptionsId = selectedEntryOption
        ? entryoptions.find(g => g.slug === selectedEntryOption)?.id
        : null;

         const eventtypeId = selectedEventType
        ? event_types.find(g => g.slug === selectedEventType)?.id
        : null;

        const venueTypeId = selectedVenueType
        ? venue_types.find(g => g.slug === selectedVenueType)?.id
        : null;


      const matchesGenre = genreId
        ? terms.some(cat => cat.id === genreId)
        : true;

          const matchesEntryOption = entryoptionsId
        ? terms.some(cat => cat.id === entryoptionsId)
        : true;

        const matchesEventType = eventtypeId
        ? terms.some(cat => cat.id === eventtypeId)
        : true;

        const matchesVenueType = venueTypeId
        ? terms.some(cat => cat.id === venueTypeId)
        : true;

      const matchesOrganizer = selectedOrganizer
        ? event.organizer?.toLowerCase().includes(selectedOrganizer.toLowerCase())
        : true;

       const matchesState = selectedState
        ? event.state?.toLowerCase().includes(selectedState.toLowerCase())
        : true;

      const matchesArtist = selectedArtist
        ? event.artist?.toLowerCase().includes(selectedArtist.toLowerCase())
        : true;

      const matchesMonth = selectedMonth
      ? new Date(event.event_date).toLocaleString('default', { month: 'long' }).toLowerCase() === selectedMonth.toLowerCase()
      : true;
      
      const matchesName = searchName
        ? event.title.rendered.toLowerCase().includes(searchName.toLowerCase())
        : true;

        const matchesKeyword = keyword
        ? (
            event.title?.rendered?.toLowerCase().includes(keyword.toLowerCase()) ||
            event.content?.rendered?.toLowerCase().includes(keyword.toLowerCase()) ||
            event.excerpt?.rendered?.toLowerCase().includes(keyword.toLowerCase()) ||
            event.artist?.toLowerCase().includes(keyword.toLowerCase()) ||
            event.organizer?.toLowerCase().includes(keyword.toLowerCase()) ||
            event.state?.toLowerCase().includes(keyword.toLowerCase()) ||
            event.categories?.some(cat =>
              cat.name?.toLowerCase().includes(keyword.toLowerCase()) ||
              cat.slug?.toLowerCase().includes(keyword.toLowerCase())
            ) ||
            event.entry_options?.some(cat =>
              cat.name?.toLowerCase().includes(keyword.toLowerCase()) ||
              cat.slug?.toLowerCase().includes(keyword.toLowerCase())
            )
          )
        : true;

      
      return  matchesGenre && matchesEntryOption && matchesEventType && matchesOrganizer  && matchesState && matchesArtist && matchesMonth  && matchesVenueType && matchesName && matchesKeyword;
    });

    setFilteredEvents(results);
  }, [
    selectedState,
    selectedGenre,
    selectedEntryOption,
    selectedEventType,
    selectedOrganizer,
    selectedArtist,
    selectedMonth,
    selectedVenueType,
    searchName,
    allEvents,
    allCategories,
    genres,
    entryoptions,
    event_types,
    venue_types
  ]);


    const updateURLParams = (key, value) => {
      const newParams = new URLSearchParams(searchParams);
      if (value) {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }
      setSearchParams(newParams);
    };
    
  const handleClearAllFilters = () => {
    setSelectedState('');
    setSelectedGenre('');
    setSelectedEventType('');
    setSelectedOrganizer('');
    setSelectedArtist('');
    setSelectedMonth('');
    setSelectedVenueType('');
    setSearchName('');
     setKeyword('');
    setSearchParams({});
    setFilteredEvents(allEvents);
  };



  const renderOptions = (categories, level = 0) => {
  return categories.flatMap((cat) => {
    const currentOption = (
      <option key={cat.id} value={cat.slug}>
        {'—'.repeat(level)} {cat.name}
      </option>
    );
    const childrenOptions = cat.children
      ? renderOptions(cat.children, level + 1)
      : [];
    return [currentOption, ...childrenOptions];
  });
};

  //// for search keyword
  useEffect(() => {
  const fetchByKeyword = async () => {
    if (!keyword) {
      setFilteredEvents(allEvents);
      return;
    }

    try {
      setIsSearching(true);
      const response = await fetch(`${wpUrl}wp-json/wp/v2/posts?search=${encodeURIComponent(keyword)}&status=publish&_embed&per_page=100`);
      const data = await response.json();

        // First filter out uncategorized posts
      const filteredData = data.filter(event => {
        const terms = event._embedded?.['wp:term']?.[0] || [];
        return !terms.some(term => term.name === "Blog" || term.slug === "blog");
      });

      // Optional: attach categories/entry_options to fetched posts
      const enrichedData = filteredData.map(event => {
        const terms = event._embedded?.['wp:term']?.[0] || [];
         
        const matchedSubCategories = terms
          .map(attached => {
            const match = allCategories.find(cat => cat.id === attached.id);
            return match ? { ...attached, type: match.type } : null;
          })
          .filter(Boolean);

        const entryOptions = terms.filter(term =>
          term.link.includes('/category/entry-options/') && term.parent !== 0
        );

        return {
          ...event,
          categories: matchedSubCategories,
          entry_options: entryOptions,
        };
      });

      setFilteredEvents(enrichedData);
    } catch (error) {
      console.error("Keyword search error:", error);
    } finally {
      setIsSearching(false);
    }
  };

  fetchByKeyword();
}, [keyword, allCategories]);

const generateEventSchema = (events) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Events List",
    "itemListElement": events.map((event, index) => ({
      "@type": "Event",
      "@id": `https://www.rsvppass.com/event-details/${event.slug}`,
      "name": cleanTitle(event.title.rendered),
      "startDate": event.date,  
      "location": {
        "@type": "Place",
        "name": event.venue || "Venue TBA",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": event.city || "TBA",
          "addressRegion": event.state || "",
          "addressCountry":event.country || "",
        }
      },
      "image": event._embedded?.['wp:featuredmedia']?.[0]?.source_url || "",
      "description": stripHtml(event.content.rendered).substring(0, 160),
      "organizer": {
        "@type": "Organization",
        "name": event.organizer || "Organizer TBA"
      },
      "performer": {
        "@type": "PerformingGroup",
        "name": event.artist || "TBA"
      },
      "offers": event.entry_options?.includes("Tickets") && event.ticket_link
        ? {
            "@type": "Offer",
            "url": event.ticket_link,
           
          }
        : undefined
    }))
  };

  return JSON.stringify(schema, null, 2);
};


    return (
        <React.Fragment>
        
         {currentEvents?.length > 0 && (
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: generateEventSchema(currentEvents),
              }}
            />
          )}
        
           <section className="locate-event">
            <div className="container">
              <div className="locate-event__inner">
                <h3 className="locate-event__title">Search Events</h3>
               
                <form className="contact-form-validated locate-event__form">
                  <div className="row">
                    <div className="col-xl-3 col-lg-3">
                        <div className="locate-event__input-box">
                        <div className="select-box">
                         
                     
                              <select className="selectmenu wide" 
                            value={selectedState}
                            onChange={(e) => {
                                const val = e.target.value;
                                setSelectedState(val);
                                updateURLParams("state", val);
                              }}>
                                <option value="">Choose State</option>
                                 {states.map((state, index) => (
                                  <option key={index} value={state}>
                                    {state}
                                  </option>
                                ))}
                            </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3">
                    <div className="locate-event__input-box">
                        <div className="select-box">
                          <select className="selectmenu wide"
                            value={selectedGenre}
                            onChange={(e) => {
                                const val = e.target.value;
                                setSelectedGenre(val);
                                updateURLParams("genre", val);
                              }}>
                            <option value="">Choose Genre</option>
                            {genres.map((genre) => (
                              <option key={genre.id} value={genre.slug}>
                                {genre.name}
                              </option>
                            ))}
                          </select>
                        
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3">
                        <div className="locate-event__input-box">
                            <div className="select-box">
                            <select className="selectmenu wide" 
                            value={selectedOrganizer}
                            onChange={(e) => {
                                const val = e.target.value;
                                setSelectedOrganizer(val);
                                updateURLParams("organizer", val);
                              }}>  

                              
                                <option value="">Choose Organizer</option>
                                 {organizers.map((organizer, index) => (
                                  <option key={index} value={organizer}>
                                    {organizer}
                                  </option>
                                ))}
                            </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3">
                      <div className="locate-event__input-box">
                        <div className="select-box">
                          <select className="selectmenu wide" 
                            value={selectedArtist}
                            onChange={(e) => {
                                const val = e.target.value;
                                setSelectedArtist(val);
                                updateURLParams("artist", val);
                              }}>
                            <option value="">Choose Artist</option>
                            {artists.map((artist, index) => (
                              <option key={index} value={artist}>
                                {artist}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3">
                      <div className="locate-event__input-box">
                        <div className="select-box">
                          <select className="selectmenu wide" 
                           value={selectedMonth}
                            onChange={(e) => {
                                const val = e.target.value;
                                setSelectedMonth(val);
                                updateURLParams("month", val);
                              }}>
                            <option value="">Choose Month</option>
                            <option value="January">January</option>
                            <option value="February">February</option>
                            <option value="March">March</option>
                            <option value="April">April</option>
                            <option value="May">May</option>
                            <option value="June">June</option>
                            <option value="July">July</option>
                            <option value="August">August</option>
                            <option value="September">September</option>
                            <option value="October">October</option>
                            <option value="November">November</option>
                            <option value="December">December</option>
                          </select>
                        </div>
                      </div>
                      
                    </div>

                     <div className="col-xl-3 col-lg-3">
                      <div className="locate-event__input-box">
                        <div className="select-box">
                          <select className="selectmenu wide" 
                            value={selectedVenueType}
                            onChange={(e) => {
                                const val = e.target.value;
                                setSelectedVenueType(val);
                                updateURLParams("venue_type", val);
                              }}>
                            <option value="">Choose Venue Type</option>
                            {venue_types.map((venue_type) => (
                              <option key={venue_type.id} value={venue_type.slug}>
                                {venue_type.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-3">
                      <div className="locate-event__input-box">
                        <div className="select-box">
                        
                              <select className="selectmenu wide"
                            value={selectedEventType}
                            onChange={(e) => {
                                const val = e.target.value;
                                setSelectedEventType(val);
                                updateURLParams("event_type", val);
                              }}>
                            <option value="">Choose Event Type</option>
                            {event_types.map((eventtype) => (
                              <option key={eventtype.id} value={eventtype.slug}>
                                {eventtype.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                     <div className="col-xl-3 col-lg-3">
                       <div className="locate-event__input-box">
                        <select className="selectmenu wide"
                            value={selectedEntryOption}
                            onChange={(e) => {
                                const val = e.target.value;
                                setSelectedEntryOption(val);
                                updateURLParams("entry_options", val);
                              }}>
                            <option value="">Choose Entry Options</option>
                            {entryoptions.map((entryoption) => (
                              <option key={entryoption.id} value={entryoption.slug}>
                                {entryoption.name}
                              </option>
                            ))}
                          </select>
                      </div>
                    </div>
                    <div className="col-xl-9 col-lg-9">
                       <div className="locate-event__input-box">
                          <div className="select-box">
                          <input
                          type="text"
                         value={keyword}
                          onChange={(e) => {
                            setKeyword(e.target.value);
                            updateURLParams("keyword", e.target.value);
                          }}
                          placeholder="Search by keyword" />
                        </div>
                      </div>
                    </div>
                  <div className="col-xl-3 col-lg-3">
                    <div className="locate-event__btn-box">
                     
                    <button type="button" className="thm-btn locate-event__btn" onClick={handleClearAllFilters}>Clear All Filters</button>
                    </div>
                  </div>
                  </div>
                </form>
                <div className="result"></div>
              </div>
            </div>
          </section>
            <section className="event-page">
            <div className="container">
              <div className="schedule-one__inner">
                <div className="section-title text-left">
                  {/* <div className="section-title__tagline-box">
                    <span className="section-title__tagline">
                      Event List
                    </span>
                  </div> */}
                  <h2 className="section-title__title">
                    Events List
                  </h2>
                </div>
                <div className="schedule-one__main-tab-box tabs-box">
                 
                  <div className="tabs-content">
                  
                    <div className='1st-day' id="1st-day"> 
                      <div className="schedule-one__tab-content-box">
                    {currentEvents.length === 0 ? (
                        <div className="no-events-message text-center">
                          <p>Oops! No events found based on the applied filters.</p>
                        </div>
                      ) : (
                      currentEvents.map(event => (
                          <div className="schedule-one__single" key={event.id}>
                              <div className="schedule-one__left">
                              <h3 className="schedule-one__title">
                                  <Link to={`/event-details/${event.slug}`}>
                                  {cleanTitle(event.title.rendered)}
                                  
                                  </Link>
                              </h3>
                              <p className="schedule-one__text">
                              {stripHtml(event.content.rendered).substring(0, 95)}...
                              
                              </p>
                                 <div className="event-details__main-tab-box tabs-box">
                                                                 

                               <ul className="tab-buttons clearfix list-unstyled">
                                {event.categories?.map((cat, index) => {
                                  let link = '/event';
                                  if (cat.type === 'venue_type') {
                                    link += `?venue_type=${encodeURIComponent(cat.slug || '')}`;
                                  } else if (cat.type === 'genre') {
                                    link += `?genre=${encodeURIComponent(cat.slug || '')}`;
                                  } else if (cat.type === 'event_type') {
                                    link += `?event_type=${encodeURIComponent(cat.slug || '')}`;
                                  }
                                     
                                  return (
                                    <li key={index} className="tab-btn">
                                      <Link to={link} target="_blank" rel="noopener noreferrer">
                                        <p>{cat.name}</p>
                                      </Link>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                              </div>
                              <div className="schedule-one__img">
                              
                              <img
                                  src={event._embedded?.['wp:featuredmedia']?.[0]?.source_url}
                                   srcSet={`
                                      ${event._embedded?.['wp:featuredmedia']?.[0]?.source_url}?w=400 400w,
                                      ${event._embedded?.['wp:featuredmedia']?.[0]?.source_url}?w=600 600w,
                                      ${event._embedded?.['wp:featuredmedia']?.[0]?.source_url}?w=800 800w
                                    `}
                                  alt={event.title.rendered}
                                  style={{ width: '100%', height: 'auto' }}
                                  loading="lazy"
                                  />
                              </div>
                              <div className="schedule-one__address-and-btn-box">
                              <ul className="list-unstyled schedule-one__address">
                                  <li>
                                      <div className="icon">
                                          <span className="icon-clock"></span>
                                      </div>
                                      <div className="text">
                                          <p>
                                          {event.long_date}
                                          </p>
                                      </div>
                                  </li>
                                  <li>
                                      <div className="icon">
                                          <span className="icon-pin"></span>
                                      </div>
                                      <div className="text">
                                          <p>
                                          {event.venue}
                                          </p>
                                      </div>
                                  </li>
                                 {event.promo_code && (
                                    <li>
                                      <div className="icon">
                                        <span className="icon-user"></span>
                                      </div>
                                      <div className="text">
                                        <p>Promo Code: {event.promo_code}</p>
                                      </div>
                                    </li>
                                  )}
                              </ul>
                            

                              <div className="schedule-one__btn-box">
                                  <ul className="footer-widget__contact-list list-unstyled">
                                      {event.entry_options?.map((entry_option) => (
                                      <li key={entry_option.id}>
                                          <div className="icon">
                                          <span className="icon-star"></span>
                                          </div>
                                          <div className="text">
                                          <Link className='text-white' to={`/event?entry_option=${encodeURIComponent(entry_option.slug || entry_option.name)}`}>
                                              {entry_option.name}
                                          </Link><br/>
                                          {entry_option.name === 'Tickets' && event.ticket_link && (
                                              <a href={event.ticket_link} target="_blank" rel="noopener noreferrer" className='px-2'>Buy Tickets Here</a>
                                          )}
                                          {entry_option.name === 'VIP Tables' && (
                                              <a onClick={() => handleSidebar(event)} target="_blank" rel="noopener noreferrer" className='px-2'>Request Table</a>
                                          )}
                                          </div>
                                      </li>
                                      ))}
                                      </ul>
                                  
                              </div>
                              </div>
                          </div>
                            ))
                          )}
                                                   
                        </div>
                        
                    </div>
                  
                  </div>
                </div>
              </div>
            </div>
          </section>
           <Sidebar isSidebar={isSidebar} 
            handleSidebar={() => setIsSidebar(false)}
            event={selectedEvent} />
      
        </React.Fragment>
    );
};

export default EventMain;
